<template>
    <div class="com-container">
        <div class="com-chart" ref="seller_erf"></div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            chartInstance: null,
            allDate: null, // 服务器返回的数据
            startValue: 0, //区域缩放起点
            endValue: 4, // 区域缩放终点
            timerId: null, // 定时器标识
            titleFontSize1: null
        };
    },
    props: {
        show: {
            type: Object,
            required: true,
        },
    },
    mounted() {
        this.initChart();
        this.getData();
        // 浏览器监听，调用次方法2
        window.addEventListener("resize", this.screenAdapter);
        // 首启浏览器适配方法调用3
        this.screenAdapter();
    },
    destroyed() {
        clearInterval(this.timerId); // 清除定时器4
        // 清除浏览器适配，防止内存泄漏4
        window.removeEventListener("resize", this.screenAdapter);
    },
    methods: {
        // 初始化echartInstance对象
        initChart() {
            this.chartInstance = this.$echarts.init(this.$refs.seller_erf, "dark");
            const initOption = {
                title: {
                    text: ` ▎(名称根据数据库数据遍历，动态)${this.show.show}环境`,
                    left: 20,
                    top: 20,
                },
                grid: {
                    top: "40%",
                    left: "3%",
                    right: "6%",
                    bottom: "5%",
                    containLabel: true, // 包含坐标轴上的文字
                },
                legend: {//筛选y轴值
                    data: ['出水温度', '回水温度', '室外温度'],
                    top: 50,
                    left: 40
                },
                yAxis: {
                    type: "value",
                    splitLine: {
                        show: false, // 隐藏网格线
                    },
                },
                xAxis: {
                    type: "category",
                },
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "line",
                        z: 0, // 层级
                        lineStyle: {
                            type: "solid",
                            color: "#2D3443",
                        },
                    },
                    valueFormatter: function (value) {
                        return value + '℃'
                    }
                },
                
                series: [
                    {
                        name: '出水温度',
                        type: "bar",
                        label: {
                            // 数值展示
                            show: true,
                            position: "top",
                            textStyle: {
                                color: "white",
                            },
                        },
                        itemStyle: {
                            color: arg => {
                                if (arg.value > 93) {
                                    return new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                        // 百分之0状态下的颜色值
                                        {
                                            offset: 0,
                                            color: "#FF3333",
                                        },
                                        // 百分之10
                                        // 0状态下的颜色值
                                        {
                                            offset: 1,
                                            color: "#EE7700",
                                        },
                                    ])
                                } else if (arg.value > 90) {
                                    return new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                        // 百分之0状态下的颜色值
                                        {
                                            offset: 0,
                                            color: "#FF8800",
                                        },
                                        // 百分之10
                                        // 0状态下的颜色值
                                        {
                                            offset: 1,
                                            color: "#99FF33",
                                        },
                                    ])
                                } else {
                                    return new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                        // 百分之0状态下的颜色值
                                        {
                                            offset: 0,
                                            color: "#55AA00",
                                        },
                                        // 百分之10
                                        // 0状态下的颜色值
                                        {
                                            offset: 1,
                                            color: "#66FF66",
                                        },
                                    ])
                                }
                            },

                            barBorderRadius: [33, 33, 0, 0], // 轴的圆弧度
                        },
                    },
                    {
                        name: '回水温度',
                        type: "bar",
                        label: {
                            // 数值展示
                            show: true,
                            position: "top",
                            textStyle: {
                                color: "white",
                            },
                        },
                        itemStyle: {
                            color: arg => {
                                if (arg.value > 93) {
                                    return new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                        // 百分之0状态下的颜色值
                                        {
                                            offset: 0,
                                            color: "#FF3333",
                                        },
                                        // 百分之10
                                        // 0状态下的颜色值
                                        {
                                            offset: 1,
                                            color: "#EE7700",
                                        },
                                    ])
                                } else if (arg.value > 90) {
                                    return new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                        // 百分之0状态下的颜色值
                                        {
                                            offset: 0,
                                            color: "#FF8800",
                                        },
                                        // 百分之10
                                        // 0状态下的颜色值
                                        {
                                            offset: 1,
                                            color: "#99FF33",
                                        },
                                    ])
                                } else {
                                    return new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                        // 百分之0状态下的颜色值
                                        {
                                            offset: 0,
                                            color: "#55AA00",
                                        },
                                        // 百分之10
                                        // 0状态下的颜色值
                                        {
                                            offset: 1,
                                            color: "#66FF66",
                                        },
                                    ])
                                }
                            },

                            barBorderRadius: [33, 33, 0, 0], // 轴的圆弧度
                        },
                    },
                    {
                        name: '室外温度',
                        type: "bar",
                        label: {
                            // 数值展示
                            show: true,
                            position: "top",
                            textStyle: {
                                color: "white",
                            },
                        },
                        itemStyle: {
                            barBorderRadius: [33, 33, 0, 0], // 轴的圆弧度
                            color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
                                // 百分之0状态下的颜色值
                                {
                                    offset: 0,
                                    color: "#5052EE",
                                },
                                // 百分之10
                                // 0状态下的颜色值
                                {
                                    offset: 1,
                                    color: "#AB6EE5",
                                },
                            ]),
                        },
                    },
                ],
            };
            this.chartInstance.setOption(initOption);
            // 鼠标移入停止
            this.chartInstance.on("mouseover", () => {
                clearInterval(this.timerId);
            });
            this.chartInstance.on("mouseout", () => {
                this.startInterver();
            });
        },
        // 获取服务器数据
        async getData() {
            const { data: ret } = await this.$http.get("wendu.JSON");
            this.allDate = ret;
            console.log(this.allDate);

            // this.allDate.sort((a, b) => {
            //     return b.value - a.value; // 从大到小
            // });
            this.updateChart();
            // 启动定时器3
            if (this.show.show==2) {
                this.startInterver();
            }
            
        },
        // 更新图标
        updateChart() {
            const sellerNames1 = this.allDate.inletTemperature.map((item) => {
                return item.time
            });
            const sellerValues1 = this.allDate.inletTemperature.map((item) => {
                return item.temperature
            });
            const sellerValues2 = this.allDate.outdoorTemperature.map((item) => {
                return item.temperature
            });
            const sellerValues3 = this.allDate.outletTemperature.map((item) => {
                return item.temperature
            });
            const dataOption = {
                xAxis: {
                    data: sellerNames1,
                },
                dataZoom: {
                    show: false,
                    startValue: this.startValue,
                    endValue: this.endValue,
                },
                series: [
                    {
                        data: sellerValues3,
                        itemStyle: {
                            barBorderRadius: [33, 33, 0, 0], // 轴的圆弧度
                        },
                    },
                    {
                        data: sellerValues1,
                        itemStyle: {
                            barBorderRadius: [33, 33, 0, 0], // 轴的圆弧度
                        },
                    },
                    {
                        data: sellerValues2,
                        itemStyle: {
                            barBorderRadius: [33, 33, 0, 0], // 轴的圆弧度
                        },
                    },
                ],
            };
            this.chartInstance.setOption(dataOption);

        },
        startInterver() {
            // 预先判断定时器是否清除，存在消除1
            if (this.timerId) {
                clearInterval(this.timerId);
            }
            // 设置定时器2
            this.timerId = setInterval(() => {
                this.startValue++
                this.endValue++
                if (this.endValue > this.allDate.inletTemperature.length - 1) {
                    this.startValue = 0
                    this.endValue = 4
                }
                this.updateChart();
            }, 2000);
        },
        // 浏览器发生变化时调用次方法，完成浏览器适配1
        screenAdapter() {
            const titleFontSize = (this.$refs.seller_erf.offsetWidth / 100) * 3.6;
            this.titleFontSize1 = titleFontSize
            console.log(this.titleFontSize1);

            const adapterOption = {
                title: {
                    textStyle: {
                        fontSize: titleFontSize,
                    },
                },
                tooltip: {
                    axisPointer: {
                        lineStyle: {
                            // 轴阴影大小
                            width: titleFontSize * 4,
                        },
                    },
                },
                series: [
                    {
                        barWidth: titleFontSize, // 轴的宽度
                    },
                    {
                        barWidth: titleFontSize, // 轴的宽度
                    },
                    {
                        barWidth: titleFontSize, // 轴的宽度
                    },
                ],
            };
            this.chartInstance.setOption(adapterOption);
            this.chartInstance.resize();
        },
    },
};
</script>
<style lang="less" scoped></style>